module.exports = __webpack_public_path__ + "static/media/LaLigua_Logo.8847f96b.svg";